var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7663 8.35044C20.3371 7.13343 19.1776 6.26089 17.8138 6.26089H15.1305C13.4016 6.26089 12 7.66246 12 9.39135C12 9.95619 12.1504 10.4991 12.4121 10.9566C11.4157 10.9484 10.4935 10.9634 9.91303 10.9566C9.91303 9.74924 9.91303 8.21127 9.91303 7.88947L10.0363 7.76619C10.5897 7.21279 10.4052 6.29047 10.4052 6.29047C10.4052 6.29047 9.48295 6.10602 8.92955 6.65943L8.28459 7.30438H7.5652C5.98036 7.30438 4.69566 8.58913 4.69566 10.1739H6.78262V12.5218C6.78262 12.8652 6.85186 13.1923 6.97697 13.4902L6.26086 14.087H5.21737V13.0435H4.17389V15.1304H8.86955V17.2174H7.82606V18.2609H9.91303V16.1739L10.8695 15.0261H13.1304L14.0869 16.1739V17.2174H13.0434V18.2609H17.2173V12.5217C17.2173 11.6573 17.9181 10.9565 18.7825 10.9565C18.8047 10.9565 18.8268 10.9573 18.8488 10.9582C18.8056 10.7909 18.7825 10.6156 18.7825 10.4348C18.7826 9.31686 19.6617 8.4043 20.7663 8.35044ZM15.1305 17.2174V15.0261H15.2174L16.1739 16.1739V17.2174H15.1305Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWales);
export default __webpack_public_path__ + "static/media/wales.7e073464e50feec072da87fabb032195.svg";
export { ForwardRef as ReactComponent };